var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "ma-0 pa-2",
      attrs: { text: "", small: "" },
      on: {
        click: function($event) {
          return _vm.params.action(_vm.params.data)
        }
      }
    },
    [_c("v-icon", [_vm._v(_vm._s(_vm.params.icon))])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }